const browser = getBrowser()

export function isSafari() {
    return browser.name === "Safari"
}

function getBrowser() {
    const userAgent=navigator.userAgent
    let browserMatches=userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

    if(/trident/i.test(browserMatches[1])) {
        const versionMatch =/\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return {name:'IE',version:(versionMatch[1]||'')};
    }
    if(browserMatches[1]==='Chrome'){
        const versionMatch =userAgent.match(/\bOPR|Edge\/(\d+)/)
        if(versionMatch!=null)   {return {name:'Opera', version:versionMatch[1]};}
    }
    browserMatches=browserMatches[2]? [browserMatches[1], browserMatches[2]]: [navigator.appName, navigator.appVersion, '-?'];
    const versionMatch = userAgent.match(/version\/(\d+)/i)
    if(versionMatch !=null) {
        browserMatches.splice(1,1,versionMatch[1]);
    }
    return {
        name: browserMatches[0],
        version: browserMatches[1]
    };
}